import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'datum': {
    title: '查询期间',
    type: 'date',
    equation: all,
    defaultVal: new Date().toLocaleDateString().replaceAll('\/', ''),
    clear: false,
    fieldDisabled: true
  },
  'product_id': {
    title: '产品',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品'
    }
  },
  'short_text': {
    title: '产品描述',
    type: 'input',
    equation: cusname
  },
  'brand': {
    title: '品牌',
    type: 'select',
    equation: city,
    dictionary: 'A0015'
  },
  'brand_bq': {
    title: 'BQ分类',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  },
  'ycate': {
    title: '月报分类',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  }
}

export default {
  'name1': {
    title: '营销单元'
  },
  'product_id': {
    title: '产品',
    width: 180
  },
  'short_text': {
    title: '产品描述',
    type: 'input',
    equation: cusname,
    width: 400
  },
  'value_brand': {
    title: '品牌'
  },
  'value_bq': {
    title: 'BQ分类'
  },
  'yuebao_kt': {
    title: '月报分类',
    width: 150
  },
  'norms': {
    title: '规格',
    type: 'input',
    equation: all,
    width: 200
  },
  'cur_qty': {
    title: '前期包材余量',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'pre_qty': {
    title: '本期包材计划量',
    width: 140,
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'sum_qty': {
    title: '本期计划合计',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'use_qty': {
    title: '已用包材',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'sub_qty': {
    title: '已提交包材',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'rem_qty': {
    title: '包材结余量',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'remark': {
    title: '备注',
    type: 'input',
    equation: all
  }
}



// WEBPACK FOOTER //
// ./src/views/material-plan-manage/config/materialPlanReport.js